import type { ObservationsBatchUpdateSeverityVariables } from "./observations.type";
import type { UseBatchOptions } from "@/hooks/queries";

import { useBatch } from "@/hooks/queries";

export const useBatchObservationsSeverity = (options?: UseBatchOptions) => {
  return useBatch<ObservationsBatchUpdateSeverityVariables>(
    "observations",
    "update",
    options
  );
};
